module.exports = __webpack_public_path__ + "static/media/folder.ad978c04.svg";